/*
 * @Author: songyzh
 * @Date: 2020-07-27 22:13:08
 * @LastEditors: songyzh
 * @LastEditTime: 2022-07-29 19:58:13
 */
import Vue from 'vue';
import Router from 'vue-router';
import storage from '@/utils/local-storage';
import routes from './routes';

Vue.use(Router);

const router = new Router({ routes });

router.beforeEach((to, form, next) => {
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = storage.getItem('user');
  if (authRequired && !loggedIn) {
    next('/login');
  } else {
    if (loggedIn) {
      const { loginname } = loggedIn;
      if (loginname === 'ZJGS' || loginname === 'zjadmin') {
        Vue.prototype.$appConfig.isZJ = true;
      } else {
        Vue.prototype.$appConfig.isZJ = false;
      }
    }

    next();
  }
});
export default router;
